import { Effect } from "effect";
import * as Command from "foldkit/command";
import { evo } from "foldkit/struct";

import {
	readTagInputVariant,
	writeTagInputVariant,
} from "../../app/developerOptions";
import type { Page, PageReturn } from "../shared";
import { Message } from "./message";
import { type Model, TagInputVariant } from "./model";

/** localStorage is I/O, so `init` reads the stored choice through a Command. */
export const ReadVariant = Command.define("ReadTagInputVariant", {
	messages: [Message.CompletedReadVariant],
	execute: Effect.sync(() =>
		Message.CompletedReadVariant({ variant: readTagInputVariant() }),
	),
});

export const PersistVariant = Command.define("PersistTagInputVariant", {
	args: { variant: TagInputVariant },
	messages: [Message.CompletedPersistVariant],
	execute: ({ variant }) =>
		Effect.sync(() => writeTagInputVariant(variant)).pipe(
			Effect.as(Message.CompletedPersistVariant()),
		),
});

export const page: Page<Model, Message> = {
	init: () => ({
		model: { page: "Developers", tagInputVariant: "external" },
		commands: [ReadVariant()],
	}),
	changedRoute: (model) => ({ model }),
	update: (model, message) =>
		Message.match<PageReturn<Model, Message>>(message, {
			CompletedReadVariant: ({ variant }) => ({
				model: evo(model, { tagInputVariant: () => variant }),
			}),
			SelectedVariant: ({ variant }) => ({
				model: evo(model, { tagInputVariant: () => variant }),
				commands: [PersistVariant({ variant })],
			}),
			CompletedPersistVariant: () => ({ model }),
		}),
};
